import React from 'react';
import { useTranslate } from 'app/translations';
import { selfKey } from 'utilities/names';

const Style = {
    container: 'flex flex-wrap w-full',
};

export const Name = ({actionType, historyData, isSelf }) => {
    const { _t } = useTranslate();
    const { before, after } = historyData;

    const name = (name) => {
        return(
            <span className="text-primary-700">
                {name}
            </span>
        )
    }
    return (
        <div className={Style.container}>
            <p>
                {_t(selfKey('ticket.history.event.name.changed', isSelf)).toLowerCase()} {name(before)} {_t('to').toLowerCase()} {name(after)}
            </p>
        </div>
    );
};
